import { Edit, InsertPhoto } from "@mui/icons-material";
import {
  Grid,
  Button,
  CardMedia,
  IconButton,
  Divider,
  Typography,
  TextField,
} from "@mui/material";
import { Formik, Form } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./editor.css";
interface ProtecMissionPhotoFormData {
  instructionOnSector: string;
  cdsInstruction: string;
  organizationConsulted: string;
  interaction: string;
  callingNumber: string;
  jobNumber: string;
  otherCenters: string;
}

const ProtectPhotoMissionForm = (props: any) => {
  const [map, setMap] = useState(
    props.protecInformations.informations?.map as any
  );
  const [update, setUpdate] = useState(false);

  const getBase64 = (file: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setMap(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error : ", error);
    };
  };
  return (
    <Formik
      initialValues={
        {
          jobNumber: props.protecInformations.informations?.jobNumber || "",
          otherCenters:
            props.protecInformations.informations?.otherCenters || "",
          instructionOnSector:
            props.protecInformations.informations?.instructionOnSector || "",
          cdsInstruction:
            props.protecInformations.informations?.cdsInstruction || "",
          organizationConsulted:
            props.protecInformations.informations?.organizationConsulted || "",
          interaction: props.protecInformations.informations?.interaction || "",
          callingNumber:
            props.protecInformations.informations?.callingNumber || "",
        } as ProtecMissionPhotoFormData
      }
      onSubmit={(values: ProtecMissionPhotoFormData, actions) => {
        const newProtecInformations = {
          instructionOnSector: values.instructionOnSector,
          cdsInstruction: values.cdsInstruction,
          organizationConsulted: values.organizationConsulted,
          interaction: values.interaction,
          callingNumber: values.callingNumber,
          jobNumber: values.jobNumber,
          otherCenters: values.otherCenters,
          map: map,
        };
        setUpdate(false);

        props.updateProtecInformations(
          newProtecInformations,
          props.protecInformations.id
        );
      }}
      validationSchema={Yup.object().shape({
        instructionOnSector: Yup.string(),
        cdsInstruction: Yup.string(),
        organizationConsulted: Yup.string(),
        interaction: Yup.string(),
        jobNumber: Yup.string().required(),
        otherCenters: Yup.string().required(),
        callingNumber: Yup.string(),
      })}
    >
      {({
        values,
        touched,
        errors,
        setFieldValue,
        handleBlur,
        handleChange,
      }) => {
        return (
          <Form noValidate>
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={5} style={{ textAlign: "center" }}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>Number of mission</Typography>
                </Divider>
                <TextField
                  inputProps={{
                    readOnly: !update,
                    style: {
                      backgroundColor: !update ? "#F2E3D5" : "", // Remplacez par votre couleur de fond souhaitée
                    },
                    disableUnderline: true, // Supprime la ligne de soulignement par défaut
                  }}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="jobNumber"
                  label="Job number"
                  name="jobNumber"
                  style={{
                    color: "white",
                    textAlign: "left",
                  }}
                  value={values.jobNumber}
                  helperText={
                    errors.jobNumber && touched.jobNumber
                      ? errors.jobNumber
                      : " "
                  }
                  error={errors.jobNumber && touched.jobNumber ? true : false}
                  onChange={(event) => {
                    setFieldValue("jobNumber", event.target.value);
                  }}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={5} style={{ textAlign: "center" }}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>other center numbers</Typography>
                </Divider>
                <TextField
                  InputProps={{
                    readOnly: !update,
                    style: {
                      backgroundColor: !update ? "#F2E3D5" : "", // Remplacez par votre couleur de fond souhaitée
                    },
                    disableUnderline: true, // Supprime la ligne de soulignement par défaut
                  }}
                  margin="normal"
                  required
                  fullWidth
                  id="otherCenter"
                  label="Other center"
                  name="otherCenter"
                  style={{
                    color: "white",
                    textAlign: "left",
                  }}
                  value={values.otherCenters}
                  helperText={
                    errors.otherCenters && touched.otherCenters
                      ? errors.otherCenters
                      : " "
                  }
                  error={
                    errors.otherCenters && touched.otherCenters ? true : false
                  }
                  onChange={(event) => {
                    setFieldValue("otherCenters", event.target.value);
                  }}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={6}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>Instruction on sector</Typography>
                </Divider>
                <ReactQuill
                  readOnly={!update}
                  style={{
                    margin: "10px",
                    backgroundColor: !update ? "#F2E3D5" : "",
                  }}
                  placeholder="Write something..."
                  theme="snow"
                  value={values.instructionOnSector}
                  onChange={(value) =>
                    setFieldValue("instructionOnSector", value)
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>CDS instructions</Typography>
                </Divider>
                <ReactQuill
                  readOnly={!update}
                  style={{
                    margin: "10px",
                    backgroundColor: !update ? "#F2E3D5" : "",
                  }}
                  placeholder="Write something..."
                  theme="snow"
                  modules={{
                    clipboard: {
                      matchVisual: false,
                    },
                  }}
                  value={values.cdsInstruction}
                  onChange={(value) => setFieldValue("cdsInstruction", value)}
                />
              </Grid>
              <Grid item xs={6}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>Organization consulted</Typography>
                </Divider>
                <ReactQuill
                  readOnly={!update}
                  style={{
                    margin: "10px",
                    backgroundColor: !update ? "#F2E3D5" : "",
                  }}
                  placeholder="Write something..."
                  theme="snow"
                  value={values.organizationConsulted}
                  onChange={(value) =>
                    setFieldValue("organizationConsulted", value)
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>Interaction</Typography>
                </Divider>
                <ReactQuill
                  readOnly={!update}
                  style={{
                    margin: "10px",
                    backgroundColor: !update ? "#F2E3D5" : "",
                  }}
                  placeholder="Write something..."
                  theme="snow"
                  value={values.interaction}
                  onChange={(value) => {
                    setFieldValue("interaction", value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Divider textAlign="center" style={{ margin: "10px" }}>
                  <Typography>Calling number</Typography>
                </Divider>
                <ReactQuill
                  readOnly={!update}
                  style={{
                    margin: "10px",
                    backgroundColor: !update ? "#F2E3D5" : "",
                  }}
                  placeholder="Write something..."
                  theme="snow"
                  value={values.callingNumber}
                  onChange={(value) => setFieldValue("callingNumber", value)}
                />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Grid
                  container
                  alignItems="center"
                  alignContent="center"
                  justifyContent="center"
                  sx={{
                    maxWidth: 280,
                    margin: "0 auto",
                    padding: "0.1em",
                  }}
                >
                  <Grid item xs={12}>
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                      style={{ backgroundColor: "#FA5D5D", color: "white" }}
                    >
                      <input
                        disabled={!update}
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => {
                          if (e.target.files !== null)
                            getBase64(e.target.files[0]);
                        }}
                      />
                      <InsertPhoto />
                    </IconButton>
                  </Grid>

                  {map !== null && map !== undefined && (
                    <Grid item xs={12}>
                      <CardMedia
                        height="250"
                        sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                        component="img"
                        src={`data:image/png;base64 ${map}`}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {update && (
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Button type="submit" variant="outlined">
                    CONFIRM
                  </Button>
                </Grid>
              )}
              {!update && (
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Button
                    variant="outlined"
                    type="button"
                    onClick={() => setUpdate(true)}
                  >
                    <Edit />
                  </Button>
                </Grid>
              )}
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ProtectPhotoMissionForm;
